import React from 'react';
import './InstitutionSelection.css';
import { LoginScreenLoading } from './LoginScreen';
import { URL } from '../variables';

class SelectFaculdade extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      faculdades: [],
      faculdade_select: 'tete',
      loading: false,
      msgErro: '',
      redirect: false
    }
  }

  change_faculdade(event) {
    this.setState({ faculdade_select: event.target.value });

  }

  // renderRedirect = () => {
  //   if (this.state.redirect) {
  //     return <Redirect to={'/'+this.state.faculdade_select.slug} />
  //   }
  // }

  get_faculdades() {
    fetch(`${URL}api/get_faculdades`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        // 'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro);

          this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false });
        }
        else {
          let selected = '';
          if (resp.faculdades.length > 0) {

            selected = resp.faculdades[0].slug;
          }
          this.setState({ faculdades: resp.faculdades, loading: false, msgErro: '', faculdade_select: selected });
          // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor', refresh: false, loadingMore: false });

      }

    })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?', refresh: false, loadingMore: false });
      });
  }

  componentDidMount() {
    this.setState({ loading: true, msgErro: '' });
    this.get_faculdades();
  }






  render() {
    return (
      <div className="candidate-select-page">
        {this.state.loading && <LoginScreenLoading />}
        {this.state.loading==false && <div id="app" className="candidate-select-shell">
          <header className="candidate-select-header">
              <img src={require('../assets/images/logo-ontest.png')} alt="OnTest" />
          </header>

          <main className="candidate-select-main">
            <section className="candidate-select-card">
              <div className="candidate-select-copy">
                <span className="candidate-auth-kicker">{"Câmera externa"}</span>
                <h1>{"Escolha seu seletivo"}</h1>
                <p>{"Selecione o seletivo em que você está inscrito para conectar a câmera externa."}</p>
              </div>

              {this.state.msgErro && <div className="candidate-select-error" role="alert">{this.state.msgErro}</div>}
              <div className="candidate-select-list">
                {this.state.faculdades.map((item,id)=>(
                  <a key={item.id || item.slug} href={'/' + item.slug + '/login'} className="candidate-select-item">
                    <div className="candidate-select-logo">
                      <img src={item.logo || require('../assets/images/logo-ontest.png')} alt={item.name} />
                    </div>
                    <div className="candidate-select-info">
                      <strong>{item.name}</strong>
                      <span>{"Acessar câmera externa"}</span>
                    </div>
                    <span className="candidate-select-action" aria-hidden="true">
                      <i className="mdi mdi-arrow-right"></i>
                    </span>
                  </a>
                ))}
                {this.state.faculdades.length == 0 && <div className="candidate-select-empty">
                  <i className="mdi mdi-school-outline"></i>
                  <strong>{"Nenhum seletivo disponível"}</strong>
                  <span>{"Tente novamente em alguns instantes."}</span>
                </div>}
              </div>
            </section>
          </main>
        </div>}
      </div>
    );
  }


}

export default SelectFaculdade;
